//====================================================
//  Function: table
//====================================================
function componentTable() {
  if ($('.js-datatable').length) {
    $('.js-datatable').DataTable({
      dom: '<"top">rt<"bottom"lp><"clear">',
      lengthMenu: [
        [10, 20, 40, -1],
        [10, 20, 40, 'All'],
      ],
      drawCallback: function () {
        if ($('.dataTables_length .form-select--small').length == 0) {
          $('.dataTables_length select').wrap(
            '<div class="d-inline-block form-select--small form-select--white margin-left-05 margin-right-05"></div>',
          )
          $('.dataTables_length select')
            .select2({
              minimumResultsForSearch: Infinity,
              placeholder: function () {
                $(this).data('placeholder')
              },
            })
            .focus(function () {
              $(this).select2('open')
            })

          selectEvents($('.dataTables_length select'))
        }
      },
    })

    $('.js-datatable').wrapAll('<div class="table-responsives"></div>')
  }
}
